export default __webpack_public_path__ + "static/media/nm_logo.1658a7bd.png";